import CnCardProtoIndex from './cn-card/protoIndex';
import CnDetailInfoProtoIndex from './cn-detail-info/protoIndex';
import CnFilterProtoIndex from './cn-filter/protoIndex';
import CnFormProtoIndex from './cn-form/protoIndex';
import CnFormDialogProtoIndex from './cn-form-dialog/protoIndex';
import CnListProtoIndex from './cn-list/protoIndex';
import CnMessageProtoIndex from './cn-message/protoIndex';
import CnNavBarProtoIndex from './cn-nav-bar/protoIndex';
import CnPageProtoIndex from './cn-page/protoIndex';
import CnResultProtoIndex from './cn-result/protoIndex';
import CnStepProtoIndex from './cn-step/protoIndex';
import CnTabProtoIndex from './cn-tab/protoIndex';
import CnTableProtoIndex from './cn-table/protoIndex';
import CnEntryPointsIndex from './cn-entry-points/protoIndex';
const bundle = [
    CnCardProtoIndex,
    CnDetailInfoProtoIndex,
    CnFilterProtoIndex,
    CnFormProtoIndex,
    CnFormDialogProtoIndex,
    CnListProtoIndex,
    CnMessageProtoIndex,
    CnNavBarProtoIndex,
    CnPageProtoIndex,
    CnResultProtoIndex,
    CnStepProtoIndex,
    CnTabProtoIndex,
    CnTableProtoIndex,
    CnEntryPointsIndex,
];
export default bundle;
